import { Box } from '@montugroup/design-system';
import Fade from '@mui/material/Fade';
import { Children, useEffect, useState } from 'react';

type FadeBannerProps = {
  children: React.ReactNode;
  interval?: number;
  fadeDuration?: number;
};

export function FadeBanner({ children, interval = 3000, fadeDuration = 200 }: FadeBannerProps) {
  const items = Children.toArray(children);
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const currentItem = items[index];

  useEffect(() => {
    if (items.length <= 1) {
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout>;

    const intervalID = setInterval(() => {
      setVisible(false);

      timeoutId = setTimeout(() => {
        setIndex((prev) => (prev + 1) % items.length);
        setVisible(true);
      }, fadeDuration);
    }, interval);

    return () => {
      clearInterval(intervalID);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [items.length, interval, fadeDuration]);

  if (items.length === 0) {
    return null;
  }

  return (
    <Fade in={visible} timeout={fadeDuration}>
      <Box>{currentItem}</Box>
    </Fade>
  );
}
